<template>
  <div>
    <div v-if="!editMode">
      <channel-detail-field v-if="channel.mode === 'sandbox'" class="mt-3">
        <div slot="label">Sandbox Phone Number:
          <span id="sandbox_phone_info"
                v-b-popover:sandbox_phone_info.html.hover.righttop="popoverTextSandboxPhone">
            <icon name="info-circle"/>
          </span>
        </div>
        <div slot="value">{{amioPhoneNumber}}</div>
      </channel-detail-field>
      <channel-detail-field class="mt-3">
        <div slot="label">Phone Number:
          <span v-if="channel.mode === 'sandbox'" id="original_phone_info"
                v-b-popover:original_phone_info.html.hover.righttop="popoverTextOriginalPhone">
            <icon name="info-circle"/>
          </span>
        </div>
        <div slot="value" v-bind:class="(channel.mode === 'sandbox') ? 'text-muted': ''">
          {{ channel.whatsapp_business_account.phone_number }}
        </div>
      </channel-detail-field>
    </div>
    <div v-else>
      <div v-if="channel.mode === 'sandbox'" class="row">
        <div class="col-4 col-xl-3 text-muted">Sandbox Phone Number:
          <span id="sandbox_phone_info_editing"
                v-b-popover:sandbox_phone_info_editing.html.hover.righttop="popoverTextSandboxPhone">
            <icon name="info-circle"/>
          </span>
        </div>
        <div class="col-8 col-xl-9">
          <div>{{amioPhoneNumber}}</div>
        </div>
      </div>
      <div class="row mt-3">
        <label for="whatsapp-phone-number" class="col-form-label col-4 col-xl-3 text-muted">Phone Number:
          <span v-if="channel.mode === 'sandbox'" id="original_phone_info_editing"
                v-b-popover:original_phone_info_editing.html.hover.righttop="popoverTextOriginalPhone">
            <icon name="info-circle"/>
          </span>
        </label>
        <div class="col-8 col-xl-9">
          <input type="text"
                 id="whatsapp-phone-number"
                 class="form-control"
                 v-model="editableData.whatsapp_business_account.phone_number">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'

  export default {
    components: {
      ChannelDetailField
    },

    store: {
      channel: 'administration.channelDetail.channel',
      editableData: 'administration.channelDetail.channelEdit.editableData'
    },

    data() {
      return {
        amioPhoneNumber: '+420 228 225 096',
        popoverTextOriginalPhone: 'The original Phone Number is not active while the channel is in Sandbox mode.',
        popoverTextSandboxPhone: 'Use this Phone Number to send a message to this channel while it is in Sandbox mode.'
      }
    },

    props: [
      'editMode'
    ],

    watch: {
      editMode: function () {
        if (this.editMode) {
          this.prepareStore()
        } else {
          this.cleanUpStore()
        }
      }
    },

    methods: {
      prepareStore() {
        // load data to store
        this.editableData = {
          whatsapp_business_account: {
            phone_number: this.channel.whatsapp_business_account.phone_number
          }
        }
      },

      cleanUpStore() {
        this.editableData = {}
      }
    },

    mounted() {
      const updateModeEvent = this.$enums.alerts.events.updateModeView
      // TODO needs to be updated with proper whatsapp link
      const docLink = 'https://docs.amio.io/v1.0/reference#messages-text'
      const sandboxPopoverText = `<b>Sandbox</b> - your <a href="${docLink}" target="_blank">Send Message</a>
        requests will be sent using common Amio WhatsApp account. Messages sent are not charged.<br/><br/>`
      const sandboxMode = {sandbox: 'Sandbox'}
      this.$emit(updateModeEvent, docLink, sandboxPopoverText, sandboxMode)
    },

    destroyed() {
      this.cleanUpStore()
    }
  }
</script>
